// src/data/grammarQuestions/businessEmail4Questions.js
export const businessEmail4Questions = [
  {
    id: 1,
    koreanQuestion: "비즈니스 이메일 4에서 자주 사용되는 표현은 무엇인가요?",
    question: "What is a commonly used phrase in business emails 4?",
    choices: {
      A: "Best regards",
      B: "See you later",
      C: "What's up",
      D: "Take care",
    },
    correctAnswer: "A",
    explanation: "비즈니스 이메일 4에서는 'Best regards'가 자주 사용됩니다.",
    translation:
      "비즈니스 이메일 4에서 자주 사용되는 표현은 'Best regards'입니다.",
    type: "businessEmail4",
  },
];
